import type { ReadOnlyField } from '../components/ReadOnlyDataGrid';
import type { AiSearchResultItem } from '../services/aiSearchService';

/** Colonna «Fonte» per griglie di suggerimenti AI. */
export const aiFonteReadOnlyField: ReadOnlyField = {
  field: 'fonte',
  headerName: 'Fonte',
  width: 280,
};

/** Etichetta fonte già normalizzata dal backend (`/ai/search`, `/ai/recommender`). */
export function aiFonteFromItem(item: Pick<AiSearchResultItem, 'fonte'>): string {
  return (item.fonte || '').trim();
}
